import { render, staticRenderFns } from "./AddVirtualPoi.vue?vue&type=template&id=5e7d08e8&scoped=true"
import script from "./AddVirtualPoi.vue?vue&type=script&lang=ts"
export * from "./AddVirtualPoi.vue?vue&type=script&lang=ts"
import style0 from "./AddVirtualPoi.vue?vue&type=style&index=0&id=5e7d08e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7d08e8",
  null
  
)

export default component.exports